import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';

import { Message } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'resdetindex',
    templateUrl: 'resdetindex.component.html',
    styleUrls: ['resdetindex.component.scss']
})
export class ResDetIndexComponent extends FormBase implements OnChanges {
    @Input() public indexData;
    @Input()
    @Output()
    public visible: boolean;

    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();
    @Output()
    public onValid: EventEmitter<any> = new EventEmitter();

    public indexForm: FormGroup;

    public selectedOrder: number = 0;
    public selectedNumOrder: number = -1;
    public disabledTypeOrder = true;
    public name = '';

    constructor(private formBuilder: FormBuilder, protected messageService: MessagesService,
        private translate: TranslateService) {
        super(messageService);

        this.initialization();

        this.indexForm = this.formBuilder.group({
            Name: null,
            Label: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]],
            NumOrder: -1,
            TypeOrder: 0,
            noligne: null,
            Type: null,
            ThumbInfo: false
        });
    }

    public ngOnInit() {}

    public ngOnChanges() {
        if (this.indexData) {
            this.indexForm.patchValue(this.indexData);
            this.selectedOrder = this.indexData.TypeOrder;
            this.selectedNumOrder = this.indexData.NumOrder;
            if (this.indexData.noligne === -1) {
                this.selectedNumOrder = -1;
            }
            this.setDisabledTypeOrder(this.selectedNumOrder);
            this.name = this.indexData.Name;
        }
    }

    public closeDia(event) {
        this.onClose.emit('close');
    }

    public onChange(event) {
        this.setDisabledTypeOrder(parseInt(event.value));
    }

    public validItem() {
        const error: Array<Message> = [];
        if (this.indexForm.invalid) {
            this.getErrorsInputs(error, this.indexForm);
        } else {
            this.indexForm.value.TypeOrder = this.selectedOrder;
            this.onValid.emit(this.indexForm.value);
        }
    }

    private setDisabledTypeOrder(aValue) {
        if (aValue === -1) {
            this.disabledTypeOrder = true;
        } else {
            this.disabledTypeOrder = false;
        }
    }

    private initialization() {
        this.keys = {
            Label: {
                label: this.translate.instant('Index_B'),
                pattern: ''
            }
        };
    }
}
